import { Component, OnInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { PopupService } from '../popup.service';
import { PopupType } from '../popup-code.enum';

@Component({
  selector: 'confirmation-popup',
  templateUrl: './confirmation.popup.component.html'

})
export class ConfirmationPopupComponent implements OnInit {

  @Input() id: string;
  @Input() popupType: PopupType;
  @Input() data?: any;
  @Input() employeeEmail: string;
  @Input() title: string;
  @Input() select: string;
  @Input() message: string;
  @Input() primaryActionLabel?: string;
  @Input() secondaryActionLabel?: string;
  @Input() unclosable: boolean = true;
  @Input() required: boolean = false;
  @Input() userpopuprequiredmessege: string;

  @Output() primaryAction?: EventEmitter<any> = new EventEmitter();
  @Output() secondaryAction?: EventEmitter<any> = new EventEmitter();
  @Output() employeeEmailChange: EventEmitter<string> = new EventEmitter<string>();


  private element: any;
  public showPopup: boolean = false;


  constructor(private modalService: PopupService, private el: ElementRef) {
    this.element = el.nativeElement;
    this.showPopup = false;
  }

  ngOnInit(): void {
    let modal = this;
    // ensure id attribute exists
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }
    // move element to bottom of page (just before </body>) so it can be displayed above everything else
    document.body.appendChild(this.element);
    this.modalService.add(this);
    if (this.title == null || this.title == "") this.title = "Employee";
    if (this.select == null || this.select == "") this.select = "Select";
  }

  // remove self from modal service when directive is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  // open modal
  open(): void {
    this.showPopup = true;
    document.querySelector("html").classList.add('unscrollable');
    document.body.classList.add('unscrollable');
  }

  // close modal
  close(): void {
    this.showPopup = false;
    document.querySelector("html").classList.remove('unscrollable');
    document.body.classList.remove('unscrollable');
  }
}

